import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from './not-found/not-found.component';
import { SiteContainerComponent } from './site-container.component';

const routes: Routes = [
    {
        path: '',
        component: SiteContainerComponent,
        children: [
            /*{
                path: '',
                // loadChildren: () => import(`./home/home.module`).then(m => m.HomeModule),
                loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
            },
            {
                path: 'partners',
                // loadChildren: () => import(`./partners/partners.module`).then(m => m.PartnersModule, ),
                loadChildren: () => import('./partners/partners.module').then(m => m.PartnersModule),
            },
            {
                path: 'categories',
                // loadChildren: () => import(`./services/services.module`).then(m => m.ServicesModule, ),
                loadChildren: () => import('./services/services.module').then(m => m.ServicesModule),
            },
            {
                path: 'events',
                // loadChildren: () => import(`./events/events.module`).then(m => m.EventsModule),
                loadChildren: () => import('./events/events.module').then(m => m.EventsModule),
            },
            {
                path: 'magazine',
                // loadChildren: () => import(`./magazine/magazine.module`).then(m => m.MagazineModule, ),
                loadChildren: () => import('./magazine/magazine.module').then(m => m.MagazineModule),
            },
            {
                path: 'how-it-works',
                // loadChildren: () => import(`./how-it-works/how-it-works.module`).then(m => m.HowItWorksModule, ),
                loadChildren:
                    () => import('./how-it-works/how-it-works.module').then(m => m.HowItWorksModule),
            },
            {
                path: 'contact',
                // loadChildren: () => import(`./contact/contact.module`).then(m => m.ContactModule),
                loadChildren: () => import('./contact/contact.module').then(m => m.ContactModule),
            },
            {
                path: 'what-is-listique',
                // loadChildren: () => import(`./what-is-listique/what-is-listique.module`).then(m => m.WhatIsListiqueModule),
                loadChildren:
                    () => import('./what-is-listique/what-is-listique.module').then(m => m.WhatIsListiqueModule),
            },
            {
                path: 'about',
                redirectTo: '/what-is-listique',
            },
            {
                path: 'legals',
                // loadChildren: () => import(`./legals/legals.module`).then(m => m.LegalsModule),
                loadChildren: () => import('./legals/legals.module').then(m => m.LegalsModule),
            },*/
            {
                path: '',
                // loadChildren: () => import(`./apply/apply.module`).then(m => m.ApplyModule),
                loadChildren: () => import('./apply/apply.module').then(m => m.ApplyModule),
            },
            { path: '404', component: NotFoundComponent },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class SiteContainerRoutingModule { }
